import { useState, type ReactNode } from "react";
import { Navigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import { shouldShowWelcome } from "../utils/entryGate";

/**
 * Wraps the home route: a first-time human visitor is sent to /welcome once; anyone who has
 * signed in, chosen "guest", or is a crawler/Lighthouse run goes straight through.
 *
 * Decided once per mount. An in-memory signed-in session also lets a visitor through, so a
 * browser with storage blocked (private mode) can't log in and then be bounced back forever.
 */
export default function EntryGate({ children }: { children: ReactNode }) {
  const { status } = useAuth();
  const [redirect] = useState(() => status === "signed-out" && shouldShowWelcome());

  if (redirect) return <Navigate to="/welcome" replace />;
  return <>{children}</>;
}
